import { Box } from "@mui/material";
import { AuthContext } from "../../../../context/AuthContext";
import { useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import usePageName from "../../../../hocs/usePageName";
import ShopOrderPreview from "./ShopOrderPreivew";

const OrderDetailsPage = () => {
  usePageName({
    heading: `Order Details`,
    caption: null,
  });
  const { id } = useParams();
  const { authToken, ezorder } = useContext(AuthContext);
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(false);

  const getOrderById = async (id) => {
    try {
      setLoading(true);
      let data = {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      };

      const response = await ezorder.get(`/shop/orders/${id}`, data);
      setOrder(response.data.order);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getOrderById(id);
  }, [id]);

  return (
    <Box>
      <ShopOrderPreview />
    </Box>
  );
};

export default OrderDetailsPage;
